import { computed, makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroResultadoApreciacaoSessaoAnterior extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Resultado de apreciação na sessão imediatamente anterior';
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoDadosComplementares: computed
        });
    }

    getValorOpcao(registro) {
        if (registro?.detalhes?.julgamentoAnterior) {
            let retorno = [];

            if (registro.detalhes.julgamentoAnterior.tipoResultadoJulgamento) {
                retorno.push(registro.detalhes.julgamentoAnterior.tipoResultadoJulgamento);
            }

            return retorno;
        }
    }

    getDescricao(valor) {
        let resultadoJulgamento = this.store.rootStore.dominioStore.tiposResultadoJulgamento.find(
            (tipoResultado) => tipoResultado.codigo === valor
        );

        return resultadoJulgamento ? resultadoJulgamento.descricao : 'Resultado de apreciação desconhecido: ' + valor;
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoJulgamentosAnteriores;
    }

    renderCarregando() {
        return this.renderCircularProgress('resultados de apreciação de sessões anteriores...');
    }
}
